import type { AuthUser, LoginResponse } from '@/types/auth'

/** Identidade da sessão — NÃO é credencial: o access vive só em memória (`acesso.ts`, faixa 25 §1). */
const AUTH_KEYS = ['tenant_id', 'user_id', 'auth_user'] as const
/** Legado anterior à faixa 25: o access morava nesta chave e num cookie legível. Só se apaga. */
const CHAVE_LEGADA = 'token'

/**
 * Identidade do login: `tenant_id`, `user_id` e um `auth_user` PARCIAL (role/permissions do login) pra os
 * guards não piscarem até o `/auth/me`. O access NÃO vem pra cá (I1): `login/page.tsx` o põe na memória.
 */
export function saveSession(data: LoginResponse): void {
  localStorage.setItem('tenant_id', data.tenant_id)
  localStorage.setItem('user_id', data.user_id)
  const partial: AuthUser = {
    user_id: data.user_id,
    tenant_id: data.tenant_id,
    tenant_name: null,
    name: '',
    username: '',
    email: null,
    avatar: null,
    role: data.role,
    permissions: data.permissions,
    sub_roles: [],
    channels: [],
    templates: [],
  }
  localStorage.setItem('auth_user', JSON.stringify(partial))
}

/**
 * Faixa 25 §1: apaga o access legado — a chave `token` e o cookie `token` (que o `middleware.ts` lia).
 * Idempotente. Roda no carregamento do portão privado e da tela de login, e em toda limpeza de sessão.
 */
export function limparLegado(): void {
  localStorage.removeItem(CHAVE_LEGADA)
  document.cookie = `${CHAVE_LEGADA}=; path=/; max-age=0;`
}

export function clearAuthStorage(): void {
  AUTH_KEYS.forEach((key) => localStorage.removeItem(key))
  limparLegado()
}
